import React from "react";
import { FaInstagram, FaFacebookF, FaYoutube, FaTwitter, FaWhatsapp, FaImages } from "react-icons/fa";
import { business } from "../data/business";
import { useSite } from "../hooks/useSite";

const icons = { instagram: FaInstagram, facebook: FaFacebookF, youtube: FaYoutube, twitter: FaTwitter };

// Social controls: verified profile links from the current site plus the
// photo gallery and WhatsApp (existing integration) controls.
export default function SocialLinks({ items = business.social, light = false, withGallery = true }) {
  const { openModal } = useSite();
  const wa = `https://wa.me/${business.phone.whatsapp.replace(/\D/g, "")}`;
  return (
    <ul className={`ro-social ${light ? "ro-social--light" : ""}`}>
      {withGallery && (
        <li>
          <button type="button" onClick={() => openModal("gallery", { index: 0 })} aria-label="Open photo gallery">
            <FaImages aria-hidden="true" />
          </button>
        </li>
      )}
      {items.map((s) => {
        const Icon = icons[s.id];
        return (
          <li key={s.id}>
            <a href={s.url} target="_blank" rel="noopener noreferrer" aria-label={`RollOver on ${s.label} (opens in a new tab)`}>
              {Icon ? <Icon aria-hidden="true" /> : s.label}
            </a>
          </li>
        );
      })}
      <li>
        <a href={wa} target="_blank" rel="noopener noreferrer" aria-label="Message RollOver on WhatsApp (opens in a new tab)">
          <FaWhatsapp aria-hidden="true" />
        </a>
      </li>
    </ul>
  );
}
